import { FEATURES } from '@/js/consts/features.const';
import { createRouter, createWebHistory } from 'vue-router';
import Sidebar from '@/vue/components/common/Sidebar';
import UnauthorizedPanel from '@/vue/components/common/UnauthorizedPanel';
import store from '@/vuex/index';
import authRoutes from './authRoutes';
import RolesService from '@/js/services/roles.service';
import WalletService from '@/js/services/wallet.service';
import api from '@/js/services/api';
const isLoggedIn = store.getters['auth/isLoggedIn'];
import { vueRoutes } from "@/router/router-const";

const routes = [
  ...authRoutes,
  {
    path: '/',
    name: 'Home',
    redirect: vueRoutes.about,
  },

  {
    path: '/market',
    name: vueRoutes.marketplace.name,
    components: {
      default: () => import('@/vue/components/pages/Marketplace/Marketplace'),
      UnauthorizedPanel,
      Sidebar,
    },
    query: {
      price_alt: null,
      country: null,
      city: null,
      rooms: null,
      area: null,
    },
    meta: {
      // The logo (and anything else) must always be able to reach the
      // marketplace, even mid-registration with KYC not finished yet -
      // users can come back to finish KYC later.
      toProceedKyc: true,
    },
  },
  {
    path: '/rent',
    name: vueRoutes.rentMarketplace.name,
    components: {
      default: () => import('@/vue/components/pages/Rent/RentMarketplace'),
      UnauthorizedPanel,
      Sidebar,
    },
  },
  {
    // a payment request from a QR code / link (2026-10-25)
    path: '/pay',
    name: 'pay-link',
    components: {
      default: () => import('@/vue/components/pages/Currencies/PayLink'),
      UnauthorizedPanel,
      Sidebar,
    },
  },
  {
    // a top-up invoice for the payer: the platform's bank account and the code (2026-10-25)
    path: '/invoice/:code',
    name: 'topup-invoice',
    components: {
      default: () => import('@/vue/components/pages/Currencies/TopupInvoicePage'),
      UnauthorizedPanel,
      Sidebar,
    },
  },
  {
    path: '/rent/offer/:id',
    name: vueRoutes.rentalDetails.name,
    components: {
      default: () => import('@/vue/components/pages/Rent/RentalDetails'),
      UnauthorizedPanel,
      Sidebar,
    },
  },
  {
    path: '/rent/create/:tokenId',
    name: vueRoutes.createRentalOffer.name,
    components: {
      default: () => import('@/vue/components/pages/Rent/CreateRentalOffer'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/rent/my',
    name: vueRoutes.myRentals.name,
    components: {
      default: () => import('@/vue/components/pages/Rent/MyRentals'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/real-estate/creation',
    name: vueRoutes.realEstateCreate.name,
    components: {
      default: () =>
        import('@/vue/components/pages/RealEstateCreate/RealEstateCreate'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/real-estate/edit/:id',
    name: vueRoutes.realEstateEdit.name,
    components: {
      default: () =>
        import('@/vue/components/pages/RealEstateCreate/RealEstateCreate'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/real-estate/creation/sales-propose',
    name: vueRoutes.createFormSalesProposal.name,
    components: {
      default: () =>
        import(
          '@/vue/components/pages/RealEstateCreate/createFormSalesPropose'
        ),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/about',
    name: vueRoutes.about.name,
    components: {
      default: () => import('@/vue/components/pages/About/AboutPage'),
      UnauthorizedPanel,
      Sidebar,
    },
    meta: {
      // The start page, reachable mid-registration like the marketplace: KYC can wait.
      toProceedKyc: true,
    },
  },
  {
    path: '/faq',
    name: vueRoutes.FAQ.name,
    components: {
      default: () => import('@/vue/components/pages/Settings/FAQ'),
      UnauthorizedPanel,
    },
    meta: {
      showHeader: false,
    },
  },
  {
    path: '/contacts',
    name: vueRoutes.contacts.name,
    components: {
      default: () => import('@/vue/components/pages/Settings/TechSupport'),
      UnauthorizedPanel,
    },
    // props: {
    //   isAuthorized: false
    // }
  },
  {
    path: '/settings',
    name: vueRoutes.settings.name,
    component: () => import('@/vue/components/pages/Settings/Settings'),
    redirect: vueRoutes.profile,
  },
  {
    path: '/settings/tech-support',
    name: vueRoutes.techSupport.name,
    components: {
      default: () => import('@/vue/components/pages/Settings/TechSupport'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
      showHeader: true,
    },
  },
  {
    path: '/settings/about',
    name: vueRoutes.settingsAbout.name,
    redirect: vueRoutes.about,
  },
  {
    path: '/settings/faq',
    name: vueRoutes.faq.name,
    components: {
      default: () => import('@/vue/components/pages/Settings/FAQ'),
      Sidebar,
      UnauthorizedPanel,
    },
    meta: {
      requiredAuth: true,
      showHeader: true,
    },
  },
  {
    path: '/settings/kyc',
    name: vueRoutes.kyc.name,
    components: {
      default: () => import('@/vue/components/pages/Settings/KYC'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/settings/profile',
    name: vueRoutes.profile.name,
    components: {
      default: () => import('@/vue/components/pages/Settings/Profile/Profile'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/real-estate',
    name: vueRoutes.realEstate.name,
    components: {
      default: () => import('@/vue/components/pages/Wallet/Wallet'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
    redirect: vueRoutes.ownedRealEstate,
    children: [
      {
        path: 'owned-real-estate',
        name: vueRoutes.ownedRealEstate.name,
        components: {
          default: () => import('@/vue/components/pages/Wallet/Wallet'),
          Sidebar,
        },
      },
      {
        path: 'on-sale',
        name: vueRoutes.realEstateOnSale.name,
        components: {
          default: () => import('@/vue/components/pages/Wallet/Wallet'),
          Sidebar,
        },
      },
      {
        path: 'partially-owned',
        name: vueRoutes.realEstateInstallment.name,
        components: {
          default: () => import('@/vue/components/pages/Wallet/Wallet'),
          Sidebar,
        },
      },
      {
        path: 'withdrawn',
        name: vueRoutes.realEstateWithdrawn.name,
        components: {
          default: () => import('@/vue/components/pages/Wallet/Wallet'),
          Sidebar,
        },
      },
      // {
      //   path: 'all',
      //   name: vueRoutes.realEstateAll.name,
      //   components: {
      //     default: () => import('@/vue/components/pages/Wallet/Wallet'),
      //     Sidebar,
      //   },
      // }
    ],
  },

  // «Оренда Нерухомості»: the landlord's side of the «Моя Нерухомість» section
  {
    path: '/real-estate/rentals',
    name: vueRoutes.rentalManagement.name,
    components: {
      default: () => import('@/vue/components/pages/RentalManagement/RentalManagement'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/real-estate/my-estate',
    name: vueRoutes.myEstate.name,
    redirect: vueRoutes.settings,
  },
  {
    path: '/real-estate/details/:id',
    name: vueRoutes.realEstateDetails.name,
    components: {
      default: () =>
        import('@/vue/components/pages/RealEstateDetails/RealEstateDetails'),
      Sidebar,
      UnauthorizedPanel,
    },
  },
  {
    path: '/real-estate/details/:id/twin',
    name: vueRoutes.digitalTwinViewer.name,
    component: () =>
      import('@/vue/components/pages/DigitalTwin/DigitalTwin'),
  },
  {
    path: '/market/:id',
    name: vueRoutes.marketplaceRealEstateDetails.name,
    components: {
      default: () =>
        import('@/vue/components/pages/RealEstateDetails/RealEstateDetails'),
      Sidebar,
      UnauthorizedPanel,
    },
  },
  {
    path: '/real-estate/part-purchase',
    name: vueRoutes.partPurchase.name,
    redirect: vueRoutes.settings,
  },
  {
    path: '/real-estate/offer/iscomissioned=:isComissioned',
    name: vueRoutes.createOffer.name,
    components: {
      default: () => import('@/vue/components/pages/CreateOffer/CreateOffer'),
      Sidebar,
    },
    props: true,
  },
  {
    path: '/real-estate/withdrawn',
    name: vueRoutes.withdrawn.name,
    redirect: vueRoutes.settings,
  },
  {
    path: '/currencies',
    name: vueRoutes.currency.name,
    components: {
      default: () =>
        import('@/vue/components/pages/Currencies/CurrenciesPage.vue'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
    // currency-usd
    redirect: vueRoutes.currencyUsd,
    children: [
      {
        path: 'platform',
        name: vueRoutes.currencyUsd.name,
        components: {
          default: () =>
            import('@/vue/components/pages/Currencies/CurrenciesPage.vue'),
          Sidebar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'metamask',
        name: vueRoutes.currencyRe.name,
        // MetaMask is switched off for now (FEATURES.metamask): old links land on the platform wallet
        beforeEnter: () => (FEATURES.metamask ? true : { name: vueRoutes.currencyUsd.name }),
        components: {
          default: () =>
            import('@/vue/components/pages/Currencies/CurrenciesPage.vue'),
          Sidebar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'affiliate',
        name: vueRoutes.currencyAffiliate.name,
        components: {
          default: () =>
            import('@/vue/components/pages/Currencies/CurrenciesPage.vue'),
          Sidebar,
        },
        meta: {
          requiredAuth: true,
        },
      },
    ],
  },
  {
    // the history lives in the wallet under each currency now (owner, 2026-10-25); old links land there
    path: '/transaction-history',
    name: vueRoutes.transactionHistory.name,
    redirect: vueRoutes.currencyUsd,
  },
  {
    // Public like /rent: guests read proposals and results, voting and
    // submitting need a login (DaoPage / DaoProposalCard, dao-svc auth).
    path: '/dao',
    name: vueRoutes.dao.name,
    components: {
      default: () => import('@/vue/components/pages/DAO/DaoPage.vue'),
      UnauthorizedPanel,
      Sidebar,
    },
  },
  {
    // the exchange («Біржа»): guests see the whole market, verified users trade
    path: '/exchange/:pair?',
    name: vueRoutes.exchange.name,
    components: {
      default: () => import('@/vue/components/pages/Exchange/ExchangePage.vue'),
      UnauthorizedPanel,
      Sidebar,
    },
  },
  {
    // public like /dao: fees and the holders' split for everyone, the user's own share when logged in
    path: '/earnings',
    name: vueRoutes.earnings.name,
    components: {
      default: () => import('@/vue/components/pages/Earnings/EarningsPage.vue'),
      UnauthorizedPanel,
      Sidebar,
    },
  },
  {
    path: '/notary-requests',
    name: vueRoutes.notaryRequests.name,
    components: {
      default: () => import('@/vue/components/pages/Notary/NotaryRequests.vue'),
      Sidebar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    // Hidden device probe for the in-browser room scanner (stage 0). Not linked
    // from any menu. Public like the twin viewer above; wallet/toProceedKyc
    // skip the onboarding redirects so it also opens for users who are logged
    // in but mid-registration. Lazy-loaded in its own chunk.
    path: '/digital-twin/scan-probe',
    name: vueRoutes.digitalTwinScanProbe.name,
    component: () =>
      import(
        /* webpackChunkName: "scan-probe" */ '@/vue/components/pages/DigitalTwin/ScanProbe'
      ),
    meta: {
      wallet: true,
      toProceedKyc: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: vueRoutes.notFound.name,
    components: {
      default: () =>
        import('@/vue/components/pages/PageNotFound/PageNotFound.vue'),
      Sidebar,
      UnauthorizedPanel,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

// A session can hold a token but no private_data: the key is only fetched
// right after login (App.vue handleAuthState), so a keys-svc hiccup at that
// moment (e.g. right after a server restart) used to trap a user who already
// has a wallet on /authorization/mnemonic for good. Fetch the key once here
// and only treat the user as wallet-less when keys-svc confirms it.
// Resolves true (restored), false (no wallet yet) or null (keys-svc failed).
let walletRestore = null;
const restoreWallet = () => {
  if (!walletRestore) {
    walletRestore = api
      .get('keys/v1/keys')
      .then((response) => {
        const keyData = response.data?.data?.[0];
        if (!keyData) return false;
        WalletService.setPrivateData(keyData);
        store.dispatch('auth/setPrivateData', keyData);
        return true;
      })
      .catch(() => null)
      .then((result) => {
        // a failed lookup is retried on the next navigation
        if (result === null) walletRestore = null;
        return result;
      });
  }
  return walletRestore;
};

router.beforeEach(async (to, from, next) => {
  const { meta } = to.matched[0];
  let walletUnknown = false;
  if (
    !meta.wallet &&
    store.getters['auth/isLoggedIn'] &&
    !localStorage.getItem('private_data')
  ) {
    walletUnknown = (await restoreWallet()) === null;
  }

  const isLoggedIn = store.getters['auth/isLoggedIn'];
  const isKycProceeded = RolesService.getKycProceedStatus();
  const isRecovered = store.getters['auth/getPrivateData']?.recovered;
  // unable access for routes required login for unlogged users

  // Redirect logged-out users from routes that require authentication
  if (meta.requiredAuth && !isLoggedIn) {
    next('/market');
    // next(vueRoutes.marketplace.name);

    return;
  } else if (to.path !== '/recovery/seed' && isLoggedIn && isRecovered) {
    next('/recovery/seed');
    return;
  }

  // Redirect logged-in users from routes that don't require authentication
  else if (meta.requiredVisitor && isLoggedIn) {
    next('/market');
    // next(vueRoutes.marketplace.name);

    return;
  }

  // keys-svc could not be asked: the user may well have a wallet, so never
  // send them to wallet creation; keep them on public pages until it answers
  else if (walletUnknown) {
    if (meta.requiredAuth) next('/market');
    else next();

    return;
  }

  // Redirect users who haven't completed the mnemonic process
  // (keys-svc confirmed above that this account has no wallet yet)
  else if (
    !meta.wallet &&
    isLoggedIn &&
    !localStorage.getItem('private_data')
  ) {
    next('/authorization/mnemonic');
    // next(vueRoutes.mnemonic.name);

    return;
  }

  // Redirect users who haven't completed the KYC process
  else if (
    !meta.toProceedKyc &&
    !isKycProceeded &&
    localStorage.getItem('private_data')
  ) {
    next('/authorization/kyc');
    // next(vueRoutes.authKYC.name);

    return;
  }
  // Allow access to the route
  next();
});

export default router;
